import { Pipe, PipeTransform } from '@angular/core';

import { getCleanedWW } from '../constants/constants';

@Pipe({ name: 'getCleanedWw' })
export class GetCleanedWwPipe implements PipeTransform {
  transform(ww: number) {
    return getCleanedWW(ww);
  }
}
